import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Categories from "./components/Categories";
import Latest from "./components/Latest";
import Spotlight from "./components/Spotlight";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const webSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "奇妙漫画网",
  url: "https://mangoselect.github.io/",
  description:
    "精选短篇漫画、脑洞短篇、创意短篇的在线阅读平台，奇思妙想创意短篇在线速看。",
  inLanguage: "zh-CN",
};

export default function Home() {
  return (
    <>
      <main>
        <Navbar />
        <Hero />
        <Featured />
        <Categories />
        <Latest />
        <Spotlight />
        <About />
        <Testimonials />
        <Faq />
        <Subscribe />
        <Footer />
        <BackToTop />
      </main>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSchema) }}
      />
    </>
  );
}